import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { faqs } from '@/mocks/comics';

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫画网',
  url: 'http://nikson.cn/',
  description: '韩漫画网提供下拉式免费漫画在线观看服务，涵盖韩国漫画大全资源。',
  email: 'hello@nikson.cn',
  address: {
    '@type': 'PostalAddress',
    addressLocality: '深圳市',
    addressRegion: '广东省',
    addressCountry: 'CN',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'hello@nikson.cn',
    availableLanguage: ['Chinese'],
    hoursAvailable: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '18:00',
    },
  },
};

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于韩漫画网',
  description: '韩漫画网 - 下拉式免费漫画在线观看平台，提供韩国漫画大全资源。了解我们的品牌故事、核心优势和联系方式。',
  url: 'http://nikson.cn/about',
  isPartOf: {
    '@type': 'WebSite',
    name: '韩漫画网',
    url: 'http://nikson.cn/',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

// Combine all schemas for the about page
const combinedSchema = {
  '@context': 'https://schema.org',
  '@graph': [orgSchema, aboutSchema, faqSchema],
};

export default function AboutPage() {
  return (
    <>
      <SEO
        title="关于我们"
        description="了解韩漫画网 - 下拉式免费漫画在线观看平台。品牌故事、发展历程、联系我们，用心打造最好的韩国漫画阅读体验。"
        keywords="韩漫画网关于我们,韩漫在线观看,韩国漫画大全,免费漫画网站"
        canonicalUrl="http://nikson.cn/about"
        schema={combinedSchema}
      />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50">
          <Breadcrumb
            items={[
              { label: '首页', to: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="px-4 md:px-6 py-12 max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
                关于我们
              </span>
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
                用心打造最好的
                <span className="font-heading italic text-primary-500">韩漫阅读体验</span>
              </h1>
              <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                韩漫画网成立于2020年，致力于为中文读者提供最优质的韩国漫画阅读服务。
                我们拥有下拉式流畅阅读体验，涵盖韩国漫画大全资源，操作简单、内容全面，是您收藏韩国漫画的最佳选择。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
              {[
                { icon: 'ri-book-read-line', title: '海量资源', desc: '涵盖恋爱、热血、奇幻、悬疑、BL、GL等全类型韩国漫画，2000+作品持续更新中' },
                { icon: 'ri-smartphone-line', title: '极佳体验', desc: '下拉式阅读设计，无需频繁翻页，在手机和电脑上都能享受流畅的阅读体验' },
                { icon: 'ri-shield-check-line', title: '正版授权', desc: '与多家韩国漫画出版社合作，为用户提供合法授权的高品质漫画内容' },
              ].map((item) => (
                <div key={item.title} className="p-6 rounded-xl bg-background-100 border border-background-200 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>

            <div className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-3">
                用户
                <span className="font-heading italic text-primary-500">口碑</span>
              </h2>
              <p className="text-sm text-foreground-500 text-center mb-8">来自漫友们的真实评价</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {[
                  { user: '漫迷小樱', text: '韩漫画网是我用过最好用的韩漫阅读平台，下拉式阅读非常顺滑，漫画更新速度也很快，每天都在追更新！', rating: 5 },
                  { user: '热血少年团', text: '分类很清晰，找漫画特别方便。武林至尊和剑与魔法都是我的最爱，每周都期待更新。', rating: 5 },
                  { user: '深夜追更人', text: '网站界面干净简洁，没有烦人的广告打扰。恶女的救赎看了三遍，每一遍都有新的感动。', rating: 5 },
                  { user: '漫画收藏家', text: '资源真的很全，很多小众韩漫也能找到。已经推荐给身边所有喜欢看漫画的朋友了！', rating: 4 },
                ].map((item) => (
                  <div key={item.user} className="p-5 rounded-xl bg-background-100 border border-background-200">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center text-accent-600 font-semibold text-sm">
                        {item.user.charAt(0)}
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-foreground-900">{item.user}</div>
                        <div className="flex gap-0.5 mt-0.5">
                          {Array.from({ length: 5 }, (_, i) => (
                            <i key={i} className={`text-xs ${i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
                          ))}
                        </div>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">&ldquo;{item.text}&rdquo;</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-3">
                常见
                <span className="font-heading italic text-primary-500">问题</span>
              </h2>
              <p className="text-sm text-foreground-500 text-center mb-8">关于韩漫画网的常见疑问解答</p>
              <div className="space-y-3 max-w-2xl mx-auto">
                {faqs.map((faq, index) => (
                  <details key={index} className="group p-5 rounded-xl bg-background-100 border border-background-200 cursor-pointer">
                    <summary className="flex items-center justify-between text-sm font-semibold text-foreground-900">
                      {faq.question}
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </details>
                ))}
              </div>
            </div>

            <div className="text-center p-8 rounded-xl bg-background-100 border border-background-200">
              <h2 className="text-lg font-heading font-bold text-foreground-900 mb-3">联系我们</h2>
              <div className="space-y-2 text-sm text-foreground-600">
                <p>
                  <i className="ri-mail-line mr-2 text-primary-500"></i>
                  邮箱：hello@nikson.cn
                </p>
                <p>
                  <i className="ri-customer-service-line mr-2 text-primary-500"></i>
                  在线客服：工作日 9:00 - 18:00
                </p>
                <p>
                  <i className="ri-map-pin-line mr-2 text-primary-500"></i>
                  地址：中国广东省深圳市南山区科技园
                </p>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}